import React from "react";
import SignupUnified from "./SignupUnified";

/**
 * Router pour l'inscription - Utilise le composant unifié
 * SignupUnified gère les différents profils (ADH, MANAGER, RETIRED)
 */
function SignupRouter() {
  return <SignupUnified />;
}

export default SignupRouter;
